import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  AccordionDetails,
  Button,
  IconButton,
  TextField
} from '@mui/material';

export const AccordionHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  fontWeight: theme.typography.fontWeightBold
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`
}));

export const SectionAddContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch'
  }
}));

export const SectionAddButton = styled(Button)(({ theme }) => ({
  whiteSpace: 'nowrap'
}));

export const CustomFieldRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  gap: '16px',
  marginBottom: '16px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export const CustomFieldColumn = styled(Box)(({ theme }) => ({
  maxWidth: '190px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '100%'
  }
}));

export const MultiValueWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '250px',
  minWidth: '250px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '100%',
    minWidth: '100%'
  }
}));

export const AddGradeButtonDesktop = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));

export const AddGradeButtonMobile = styled(Button)(({ theme }) => ({
  display: 'none',
  marginBottom: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    display: 'flex'
  }
}));

export const GradeDeleteIconButton = styled(IconButton)(({ theme }) => ({
  marginTop: theme.spacing(0.5)
}));

export const AddNewSectionTextField = styled(TextField)(({ theme }) => ({
  maxWidth: '60%',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%'
  }
}));
